<template>
  <div class="logout-container">
    <div class="logout-card">
      <div class="logout-header">
        <div class="success-icon-wrapper">
          <div class="success-checkmark">
            <i class="fa fa-check"></i>
          </div>
        </div>
        <img alt="iPOS logo" src="../assets/iPosCafe-Logo.png" class="logout-logo">
        <!-- <h2 class="app-title">iPOS Cafe</h2> -->
      </div>

      <div class="logout-body">
        <h3 class="logout-title">You've Successfully Logged Out</h3>
        <p class="logout-message">
          Your session has been securely closed. Thank you for using iPOS Cafe.
        </p>

        <div class="logout-info">
          <div class="info-item">
            <i class="fa fa-clock-o"></i>
            <span>Session ended at {{ currentTime }}</span>
          </div>
        </div>

        <div class="logout-actions">
          <b-button
            variant="primary"
            size="lg"
            class="login-button"
            @click="goLogin()">
            <i class="fa fa-sign-in"></i> Log In Again
          </b-button>

          <p class="helper-text">
            Ready to get back to work? Log in to continue.
          </p>
        </div>

        <div class="security-tips">
          <h5><i class="fa fa-info-circle"></i> Security Tips</h5>
          <ul>
            <li>Always log out when leaving your workstation</li>
            <li>Never share your login credentials</li>
            <li>Close this browser window when done</li>
          </ul>
        </div>
      </div>

      <div class="logout-footer">
        <a href="https://www.newcare.international" target="_blank" class="branding-link">
          Built with <i class="fa fa-heart"></i> by Newcare International
          <span class="company-badge">(an IOIHAN company)</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogOut',
  data() {
    return {
      currentTime: ''
    }
  },
  mounted() {
    this.$root.logout();
    this.setCurrentTime();
  },
  methods: {
    goLogin() {
      this.$router.push({ name: 'login' })
    },
    setCurrentTime() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.logout-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.logout-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 540px;
  width: 100%;
  overflow: hidden;
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logout-header {
  text-align: center;
  padding: 40px 40px 20px;
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  position: relative;
}

.success-icon-wrapper {
  margin-bottom: 20px;
}

.success-checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.5s ease-out 0.2s both;

  i {
    color: white;
    font-size: 40px;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.logout-logo {
  max-width: 240px;
  height: auto;
  margin: 10px 0;
}

.app-title {
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin: 10px 0 0;
}

.logout-body {
  padding: 30px 40px 40px;
}

.logout-title {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: center;
}

.logout-message {
  color: #6c757d;
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.6;
}

.logout-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: center;
  color: #495057;
  font-size: 14px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  i {
    color: #667eea;
    font-size: 18px;
    width: 30px;
    margin-right: 10px;
  }
}

.logout-actions {
  text-align: center;
  margin-bottom: 30px;
}

.login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: 100%;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  i {
    margin-right: 8px;
  }
}

.helper-text {
  color: #6c757d;
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 0;
}

.security-tips {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  padding: 20px;

  h5 {
    color: #856404;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;

    i {
      margin-right: 8px;
    }
  }

  ul {
    margin: 0;
    padding-left: 20px;
    color: #856404;
    font-size: 14px;

    li {
      margin-bottom: 8px;
      line-height: 1.5;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.logout-footer {
  background: #f8f9fa;
  padding: 20px 40px;
  text-align: center;
  border-top: 1px solid #e9ecef;
}

.branding-link {
  color: #6c757d;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #495057;
    text-decoration: none;
  }

  i.fa-heart {
    color: #e74c3c;
    margin: 0 4px;
    animation: heartbeat 1.5s ease-in-out infinite;
  }
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.company-badge {
  display: block;
  font-size: 12px;
  color: #adb5bd;
  margin-top: 4px;
}

@media (max-width: 576px) {
  .logout-card {
    margin: 20px;
  }

  .logout-header,
  .logout-body,
  .logout-footer {
    padding-left: 25px;
    padding-right: 25px;
  }

  .logout-title {
    font-size: 20px;
  }

  .app-title {
    font-size: 24px;
  }
}
</style>

